import { useTranslation } from "react-i18next";
import { ItemReferenceName } from "../../items";
import type { GraphNode, GraphPort } from "./workflowGraph";
import { stepPortLabel } from "./stepPortLabel";

/** The same pinned item name as its card; an unreadable item keeps a technical key. */
export function StepName({ node, stepKey, showVersion = false }: { node: GraphNode | undefined; stepKey: string; showVersion?: boolean }) {
  if (node?.kind !== "step" && node?.kind !== "sub_workflow") return <code>{stepKey}</code>;
  const name = node.kind === "step" ? node.step?.name : node.workflow?.name;
  return <span className={name === undefined ? "font-mono" : undefined}><ItemReferenceName reference={node.reference} knownName={name} fallback={stepKey} showVersion={showVersion} /></span>;
}

export function PortName({ node, name, direction }: { node: GraphNode | undefined; name: string; direction: GraphPort["direction"] }) {
  const { t, i18n } = useTranslation();
  const label = stepPortLabel(node, name, direction, t, i18n.resolvedLanguage);
  return label === null ? <code>{name}</code> : <>{label}</>;
}

/** A step and one of its ports, with readable names rather than a key.part address. */
export default function StepPortName({ node, stepKey, name, direction }: { node: GraphNode | undefined; stepKey: string; name: string; direction: GraphPort["direction"] }) {
  return <><StepName node={node} stepKey={stepKey} />, <PortName node={node} name={name} direction={direction} /></>;
}
